<template>
  <h2 v-if="title" class="heading-2">{{ title }}</h2>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import type { StepId } from '~/api/reviews/types/GetReviewCollectionResponse'

import translations from './Title.translations'

const props = defineProps<{
  stepId: StepId | null
  model: string
}>()

const i18n = useI18n()

const title = computed(() => {
  switch (props.stepId) {
    case 'product_comment':
      return i18n(translations.productComment, { model: props.model })
    case 'details':
      return i18n(translations.details, { model: props.model })
    case 'attachments':
      return i18n(translations.attachments)
    case 'main':
    default:
      return ''
  }
})
</script>
